/**
 * Helpers for guided PDP optionsGroupingUI (c_optionsGroupingUIProcessed).
 * Used when merging BM-driven preselection into draft/committed selection maps.
 */

import {getOptionsGroupingUIProcessed} from '@amblique/king-living/app/utils/product-utils';

export {filterVisibleOptionProducts, mergePreselectedSelectionsFromProduct} from '@amblique/king-living/app/utils/customize-selections';

/**
 * Resolve display label for a slot from product metadata when selection objects omit it
 * (e.g. SFRA left value.typeName null, or older sessions had no recommendationName).
 *
 * @param {Object|null} product - Master / editing product with c_optionsGroupingUIProcessed
 * @param {string} stepId - containerId
 * @param {number} slotIndex - index in container.values
 * @returns {string|null}
 */
export function resolveRecommendationNameFromProduct(product, stepId, slotIndex) {
  if (!product || stepId == null || slotIndex == null) return null;

  const containers = getOptionsGroupingUIProcessed(product);

  if (!Array.isArray(containers)) return null;

  const container = containers.find((c) => c?.containerId === stepId);

  if (!container?.values?.length) return null;

  const value = container.values[slotIndex];

  if (!value) return null;

  return value.typeName || container.containerName || null;
}
